import { render, staticRenderFns } from "./AccountFooter.vue?vue&type=template&id=7ff1cb46&scoped=true&"
import script from "./AccountFooter.vue?vue&type=script&lang=js&"
export * from "./AccountFooter.vue?vue&type=script&lang=js&"
import style0 from "./AccountFooter.vue?vue&type=style&index=0&id=7ff1cb46&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff1cb46",
  null
  
)

export default component.exports